export default {
  "CAN通信接口板卡": "Can Communication Interface Board",
  "CMOS类型": "Cmos Type",
  "DCP软件版本": "DCP Software Version",
  "EHUB": "Ehub",
  "ehub下电表": "Ehub Off The Meter",
  "ems": "Ems",
  "excel信息200行内不能有空行数据": "Excel Information Line 200 Cannot Contain Empty Rows Of Data",
  "ICCID卡号": "Iccid Card Number",
  "ICCID卡号长度不能超过20": "The Length Of The Iccid Card Number Cannot Exceed 20",
  "IMSI码长度不能超过20": "The Length Of The Imsi Code Cannot Exceed 20",
  "PCS版本信息": "PCS Version Information",
  "RS485": "Rs485",
  "SMP软件版本": "SMP Software Version",
  "total-items": "{total} Items",
  "V2G": "V2g",
  "三方二维码长度不能大于20": "The Length Of The Three-party Qr Code Cannot Be Greater Than 20",
  "上一步": "Previous",
  "上传": "Upload",
  "上传图片": "Upload picture",
  "上传失败": "Upload Failure",
  "上传并校验": "Upload And Verify",
  "上传成功": "Upload Successfully",
  "上传文件": "Upload file",
  "上传文件限制最大值提示语": "File Cannot Exceed{size}mb",
  "上传枪数量至多为200": "The Maximum Number Of Guns Uploaded Is 200",
  "上传校验失败！": "Upload Verification Failed!",
  "上传校验成功！": "Upload Verification Successful!",
  "上传模板": "Upload Template",
  "上传版本": "Upload Version",
  "上报时间": "Reporting Time",
  "上架或发布固件版本提示": "{text}this Firmware Version",
  "删除固件版本提示": "Delete this firmware version?",
  "上级菜单": "Parent Menu",
  "上线时间格式错误": "The Online Time Format Is Incorrect",
  "下一步": "Next",
  "下发失败": "Delivery Failure",
  "下发成功": "Delivered Successfully",
  "下架": "Delist",
  "下载失败文档": "Download Failed Document",
  "下载模板": "Download Template",
  "不允许输入纯空格": "Pure Spaces Are Not Allowed",
  "不可修改，请谨慎填写，无组织机构代码时，请输入负责人身份证号": "Cannot Be Modified, Please Fill In Carefully, No Organization Code, Please Enter The Responsible Person Id Number",
  "不可输入中文": "No Chinese Input",
  "不能输入 -": "Can not enter \"-\"",
  "专用内部": "Private Interior",
  "专用开放": "Exclusive Opening",
  "两次密码不一致": "Two Passwords Do Not Match",
  "个人": "Personage",
  "中文按钮名称": "Chinese Button Name",
  "中文菜单名称": "Chinese Menu Name",
  "主板": "Main Board",
  "事业单位": "Public Institution",
  "亚太": "Asia Pacific",
  "交流": "Ac",
  "交流桩": "Alternating Current Pile",
  "产品名称长度不能大于50": "The Product Name Cannot Be Longer Than 50 Characters",
  "产品序列": "Product Sequence",
  "产品序列与物料编码": "Product Sequence And Material Code",
  "产品序列号": "Product Serial Number",
  "产品序列名称": "Product Sequence Name",
  "产品序列需关联至少一个物料编码": "The Product Sequence Must Be Associated With At Least One Material Code",
  "人人场站": "Renren Station",
  "人员": "Personnel",
  "物料号": "Material Code",
  "仅支持上传2张.png文件，大小不超1mb": "Only Two.png Files With A Maximum Size Of 1mb Can Be Uploaded",
  "仅支持数字": "Digit Only",
  "仅支持精准查询": "Only Precise Query Is Supported",
  "仅运维": "Operation And Maintenance Only",
  "他营": "Othercamp",
  "任务名称": "Task Name",
  "任务状态": "Task Status",
  "任务类型": "Task Type",
  "任务编号": "Task Number",
  "任务范围": "Task Scope",
  "任务范围选择": "Task Scope Selection",
  "任务选择": "Select A Task",
  "企业": "Enterprise",
  "企业单位": "Enterprise Unit",
  "企业名称": "Enterprise name",
  "企业法人": "Enterprise Legal Person",
  "企业状态": "Enterprise Status",
  "企业管理": "Enterprise Management",
  "企业类型": "Type Of Enterprise",
  "企业角色关系": "Corporate Role Relationship",
  "保存": "Save",
  "保存后此账户名称为登录账号，密码为初始密码123456": "After Saving, The Account Name Is The Login Account And The Initial Password Is 123456",
  "保存后用户名称将被实际使用，建议填写真实姓名": "After Saving, The User Name Will Be Used. You Are Advised To Enter The Real Name",
  "修改": "Edit",
  "修改成功": "Modified Successfully",
  "修改状态": "Modified State",
  "修改状态为": "Change The Status To",
  "修改配置": "Modify Configuration",
  "储能": "Stored Energy",
  "储能中": "In Energy Storage",
  "储能计量表": "Energy Storage Meter",
  "充满": "Be Filled With",
  "充电中": "Charging",
  "充电枪": "Charging Connector",
  "充电枪型号不能为空": "The Charging Gun Model Cannot Be Empty",
  "充电枪型号长度不能大于50": "The Length Of The Charging Gun Model Cannot Be Greater Than 50",
  "充电枪接口标准不能为空或者数据错误": "The Charging Gun Interface Standard Cannot Be Null Or Have Incorrect Data",
  "充电枪类型和设备类型不对应": "The Charging Gun Type Does Not Match The Device Type",
  "充电枪编号": "Charging Connector Id",
  "充电枪编号不符合规则": "The Charging Connector Id Doesn't Match The Rules",
  "充电枪编号不能为空": "The Charging Connector Id Cannot Be Empty",
  "充电枪编号重复": "Duplicate Gun Number",
  "充电桩": "Charger",
  "充电模块": "Charging Module",
  "光伏": "Solar Power",
  "光伏设备": "Photovoltaic Equipment",
  "光储一体机": "Optical Storage Machine",
  "入户智能电表": "Smart Electricity Meter For Household",
  "全部": "All",
  "全部选择": "Select All",
  "公共场站": "Public Yard",
  "公司员工": "Company Employee",
  "公司地址": "Company Address",
  "关系绑定": "Relational Binding",
  "最多可选1000场站": "Up To 1000 Stations Can Be Selected",
  "最多可选200场站": "Up To 200 Stops Are Available",
  "最多可选500场站": "Up To 500 Stops Are Available",
  "最多可选中1000台设备": "A Maximum Of 1000 Devices Can Be Selected",
  "最多可选中200台设备": "A Maximum Of 200 Devices Can Be Selected",
  "最多可选中500台设备": "Up to 500 devices can be selected",
  "最多输入100字": "Enter A Maximum Of 100 Characters",
  "最多输入100字符": "Enter A Maximum Of 100 Characters",
  "最多输入120字": "Enter A Maximum Of 120 Characters",
  "最多输入20字符": "Enter A Maximum Of 20 Characters",
  "最大": "Max",
  "最少输入4字符": "Enter At Least 4 Characters",
  "最新上报时间": "Last Report Time",
  "最新固件版本": "Latest Firmware Version",
  "最新更新": "Latest Update",
  "最新版本": "Latest Version",
  "最新版本切换提醒": "Latest Version Switch Alert",
  "最近一次上报时间": "Last Time It Was Reported",
  "分页总条数": "Amount To{total}article",
  "创建": "Create",
  "创建人": "Creator",
  "创建任务": "Create Task",
  "创建并执行": "Create And Execute",
  "创建时间": "Creation time",
  "初始状态": "Initial State",
  "删除": "Delete",
  "删除后，用户无法登录系统，您确定要删除吗": "After Deletion, The User Cannot Log In To The System. Are You Sure You Want To Delete It",
  "删除后，用户无法绑定该角色，您确定要删除吗？": "After Deleting The Role, The User Cannot Bind The Role. Are You Sure You Want To Delete It?",
  "删除成功": "Successfully Deleted",
  "刷新": "Refresh",
  "加盟直营": "Joint Direct Operation",
  "助记码": "Mnemonic Code",
  "区域": "Region",
  "升级中": "Leveling Up",
  "升级内容": "Upgrade Content",
  "升级前固件版本": "Firmware Version Before Upgrade",
  "升级后固件版本": "Firmware Version After Upgrade",
  "升级固件版本": "Upgrade Firmware Version",
  "升级失败": "Upgrade Failure",
  "升级成功": "Upgrade Successfully",
  "升级方式": "Upgrade Mode",
  "升级进度": "Upgrade Progress",
  "升至最新版本": "Upgrade To Latest Version",
  "升至指定版本": "Upgrade To Specified Version",
  "协议标准": "Protocol Standard",
  "原信息": "Primary Information",
  "发布": "Publish",
  "发布人": "Publisher",
  "发布时间": "Release Time",
  "发送方式": "Sending Method",
  "发送时间": "Sending Time",
  "取消": "Cancel",
  "取消选中": "Uncheck",
  "取消选择": "Deselect",
  "变压器数据采集接口板卡": "Transformer Data Acquisition Interface Board",
  "合同编号不能为空": "The Contract Number Cannot Be Empty",
  "合同编号长度不能超过128": "The Length Of The Contract Number Cannot Exceed 128",
  "否": "No",
  "启用": "Enable",
  "告警周期": "Alarm Period",
  "员工姓名": "Employee Name",
  "命令下发失败": "Command Delivery Failure",
  "命令下发成功": "Succeeded In Sending The Command",
  "品牌": "Brand",
  "固件升级": "Firmware Upgrade",
  "固件号": "Firmware Number",
  "固件号不匹配": "The Firmware Number Does Not Match",
  "固件号为空": "The Firmware Number Is Empty",
  "固件版本": "Firmware Version",
  "固件版本信息": "Firmware Version Information",
  "国家": "Nation",
  "国家代码": "Country Code",
  "国际化标签格式错误": "Internationalization label format error",
  "图标": "Icon",
  "在建中": "Under Construction",
  "在线预约中": "Online Booking",
  "地区": "District",
  "地址": "Address",
  "场站名称": "Station Name",
  "场站类型": "Yard Type",
  "型号": "Model Number",
  "基本信息": "Basic Information",
  "基础信息": "Basic Information",
  "增加“批量升级延时等待”功能，在3小时内请勿重复下发": "Added The Batch Upgrade Delay Function. Do Not Deliver The Batches Repeatedly Within 3 Hours",
  "备注": "Remark",
  "大版本": "Large Edition",
  "大版本号": "Major Version Number",
  "失败": "Fail",
  "失败原因": "Failure Reason",
  "姓名": "Name",
  "子系统信息": "Subsystem Information",
  "子菜单": "Submenu",
  "字数不能少于10个字": "No less than 10 words",
  "字数范围0-210个字": "Word Range 0-210 Characters",
  "字段格式范围": "Field Format Range",
  "存在校验失败数据，无法确认": "There is verification failure data and cannot be confirmed",
  "存在没有关联物料编码的产品序列，请补充": "There Are Product Sequences Without Associated Material Codes, Please Add",
  "安装信息总长度不能超过128": "The Total Length Of Installation Information Cannot Exceed 128",
  "安装服务商应输入9位数字或大小写字母": "Installation Provider Should Enter 9 Digits Or Upper And Lower Case Letters",
  "安装质保开始日期不能大于结束时间": "The Installation Warranty Start Date Cannot Be Longer Than The End Time",
  "安装质保开始日期和结束日期必须同时存在": "The Installation Warranty Start Date And End Date Must Exist Simultaneously",
  "安装质保开始结束时间格式错误": "The Installation Warranty Start And End Time Format Is Incorrect",
  "完成创建": "Complete Creation",
  "定时": "Timing",
  "定时执行": "Timed Execution",
  "客户": "Client",
  "密码重置成功": "Password Reset Succeeded",
  "导入户储设备": "Import Household Storage Equipment",
  "导入结果": "Import Result",
  "导入记录": "Import Record",
  "导入设备": "Import Device",
  "导出": "Export",
  "小版本": "Mini Version",
  "工号": "Job Number",
  "已发布": "Published",
  "已取消": "Cancelled",
  "已执行": "Executed",
  "已读": "Read",
  "已选择": "Selected",
  "序号": "Index",
  "开始日期": "Start Date",
  "异常数量": "Abnormal Quantity",
  "当前固件号": "Current Firmware Number",
  "当前固件版本": "Current Firmware Version",
  "当前固件版本下暂无文件，请重新选择": "There are no files in the current firmware version. Please select again",
  "当前版本已是最新版本，若要切换，可设置其他版本为最新版本": "The Current Version Is The Latest Version. If You Want To Switch, You Can Set Another Version To The Latest Version",
  "当前状态": "Current State",
  "当前硬件类型": "Current Hardware Type",
  "当前选中设备": "Currently Selected Device",
  "必填项不能为纯空格": "The Required Fields Cannot Be Spaces Only",
  "成功": "Success",
  "成功{susNum}条,失败{failNum}条": "Success {susNum}, Failure {failNum}",
  "成功数量": "Successful Quantity",
  "我知道了": "I Know.",
  "所属场站": "Charging Station",
  "手动": "Manual",
  "手机号": "Mobile phone number",
  "执行": "Carry Out",
  "执行方式": "Execution Mode",
  "执行时间": "Execution Time",
  "批量修改": "Batch Modification",
  "批量固件升级校验结果1": "Successful{susNum}indicates 0 Failures",
  "批量导入": "Batch Import",
  "批量新增": "Batch Addition",
  "批量新增设备": "Batch Add Devices",
  "批量新增设备校验结果1": "Successful{susNum}indicates 0 Failures",
  "批量新增设备校验结果2": "Successful{susNum}bar, Failure{failNum}article,",
  "批量桩群转移": "Batch Charger Transfer",
  "批量移除": "Batch Removal",
  "批量选择": "Batch Selection",
  "按钮": "Button",
  "排序": "Sort",
  "控制拓扑": "Control Topology",
  "提交": "Submit",
  "插枪空闲": "Gun Free",
  "搜索数量小于1000，可直接选择全部设备": "If The Number Of Searches Is Less Than 1000, You Can Directly Select All Devices",
  "搜索数量小于200，可直接选择全部搜索出的设备": "If The Number Of Searched Devices Is Less Than 200, You Can Directly Select All Searched Devices",
  "搜索数量小于200，可直接选择全部设备": "If The Number Of Searches Is Less Than 200, You Can Directly Select All Devices",
  "搜索数量小于500，可直接选择全部搜索出的设备": "If The Number Of Searched Devices Is Less Than 500, You Can Directly Select All Searched Devices",
  "操作": "Controls",
  "操作人": "Operator",
  "操作成功": "Successful operation",
  "操作日志": "Operation Log",
  "操作时间": "Operating Time",
  "操作桩数量": "Number Of Operating Piles",
  "操作类型": "Type Of Operation",
  "操作系统": "Operating System",
  "操作记录": "Operation Record",
  "政府部门": "Government Department",
  "故障": "Breakdown",
  "故障名称": "Fault Name",
  "故障点": "Trouble Spot",
  "故障点编码": "Fault Point Coding",
  "故障码": "Trouble Code",
  "数据包": "Data Packet",
  "数量": "Quantity",
  "文件下载": "File Download",
  "文件名": "Filename",
  "新信息": "New Information",
  "新增固件": "New Firmware",
  "新增固件(旧版)": "New firmware (old version)",
  "新增成功": "New Success",
  "新增用户": "Add New User",
  "新增角色": "New Role",
  "新增通知": "Add Notification",
  "新密码": "New Password",
  "新建": "New",
  "新建任务": "New Task",
  "新建企业": "Newly Established Enterprise",
  "方式": "Way",
  "旧": "The old",
  "时区预览": "Time Zone Preview",
  "星充直营": "StarCharge Direct Operation",
  "是": "Yes",
  "是否发版": "Issue Or Not",
  "是否对外发布": "Whether To Publish",
  "是否弹窗": "Whether Popup",
  "是否批量移除设备？": "Do You Want To Remove Devices In Batches?",
  "是否用电表": "Whether To Use An Electric Meter",
  "是否移除该设备？": "Do You Want To Remove The Device?",
  "是否设为最新版本？": "Is It Set To The Latest Version?",
  "显示排序": "Display Sort",
  "普通用户": "Ordinary User",
  "暂不支持粘贴图片，请从工具栏中上传": "Pasting picture is not supported yet, please upload from the toolbar",
  "更多": "More",
  "更改前场站名称": "Station name before change",
  "更改前屏保图片": "Change Screensaver Before Picture",
  "更改后场站名称": "Station name after change",
  "更改后屏保图片": "Screen Save Picture After Change",
  "更改设备屏保": "Change Your Device Screensaver",
  "更新时间": "Update Time",
  "有效版本数": "Number Of Valid Versions",
  "未发布": "Unpublished",
  "未执行": "Unexecuted",
  "未查询到与之匹配的目标版本": "No Matching Target Version Was Queried",
  "未读": "Unread",
  "权限标识": "Permission Identification",
  "条": "Item",
  "枪功率大小范围为0~9998": "Gun Power Ranges From 0 To 9998",
  "查看": "View",
  "查看任务": "View Task",
  "查看角色": "View Roles",
  "查询": "Query",
  "标准不能为空或者数据错误": "Criteria Cannot Be Empty Or Have Incorrect Data",
  "标识权限": "Identification Authority",
  "校验": "Verify",
  "校验失败": "Check Failure",
  "校验导入": "Check Import",
  "校验已完成": "Check Completed",
  "校验并创建": "Check And Create",
  "校验成功": "Check Success",
  "校验数量": "Check Quantity",
  "校验结果": "Check Result",
  "桩配置信息": "Charger Configuration Information",
  "检测存有异常设备": "Abnormal Devices Are Detected",
  "模板下载": "Template Download",
  "次数": "Frequency",
  "欧洲": "Europe",
  "正常": "Normal",
  "正常数量": "Normal Quantity",
  "没有改动项": "Unchanged Item",
  "注：": "Note:",
  "注：上传模板前先线下编辑好excel文件，批量新增枪数量不大于200个，超过时建议减少桩数量，分批导入": "Note: Edit the excel file offline before uploading the template. The number of guns added in batches should not exceed 200. If more than 200 guns are added, it is recommended to reduce the number of piles and import them in batches",
  "注:此处下载的配置文件里面会标注出异常配置内容": "Note: Abnormal Configurations Are Marked In The Configuration File Downloaded Here",
  "注：点击获取桩群批量转移模版，上传模版前先线下修改好excel表格中对应关系，批量新增桩群对应关系不大于1000个，超过时建议减少桩数量，分批导入": "Note: Click here to get the template for batch transfer of chargers. Before uploading the template, modify the corresponding relationship in the Excel table offline. The number of corresponding relationships of newly added chargers in batches should not exceed 1000. If it exceeds this number, it is recommended to reduce the number of chargers and import them in batches.",
  "流式传输": "needSupply",
  "流式传输,请选择小于500KB的文件": "For streaming, please select files smaller than 500KB",
  "浏览器": "Browser",
  "添加": "Add",
  "添加产品序列": "Add Product Sequence",
  "添加成功": "Add Successfully",
  "添加文件": "Add File",
  "添加设备": "Add Device",
  "清空已选设备": "Clear Selected Devices",
  "点击上传": "Click To Upload",
  "点击获取配置文件下载模板，上传模板前先线下修改好excel配置文件": "Click [Get Configuration File] to download the configuration file template. Upload the file after modifying. The number of devices in the configuration file does not exceed 200.",
  "版本内容": "Version Content",
  "版本号": "Version Number",
  "版本详情": "Version Details",
  "版本说明": "Version Description",
  "物料描述": "Material Description",
  "物料编码": "Material Code",
  "物流单号长度不能超过30": "The Length Of The Tracking Number Cannot Exceed 30",
  "状态": "Status",
  "生产厂商": "Manufacturer",
  "生产厂商不能为空": "The Manufacturer Cannot Be Empty",
  "生产厂商应输入9位数字或大小写字母": "The Manufacturer Should Enter 9 Digits Or Upper And Lower Case Letters",
  "用户名称": "User name",
  "用户类型": "User Type",
  "电压上限不能为空": "The Upper Voltage Limit Cannot Be Empty",
  "电压上限大小范围为0~9999": "The Upper Voltage Limit Ranges From 0 To 9999",
  "电压下限不能为空": "The Lower Voltage Limit Cannot Be Empty",
  "电压下限大小范围为0~9999": "The Voltage Lower Limit Ranges From 0 To 9999",
  "电池": "Battery",
  "电池额定功率（kW）": "Rated Battery Power (kw)",
  "电池额定容量（kWh）": "Rated Battery Capacity (kwh)",
  "电源类型不能为空或者数据错误": "The Power Supply Type Cannot Be Empty Or The Data Is Incorrect",
  "登录IP": "Login Ip",
  "登录人员": "Logged-in Person",
  "登录日志": "Entry Log",
  "登录时间": "Login Time",
  "监测数据": "Monitoring Data",
  "目标平台": "Target Platform",
  "目标版本不能为空": "The Target Version Cannot Be Empty",
  "直流": "Dc",
  "硬件SN码": "Hardware Sn Code",
  "硬件信息": "Hardware Information",
  "硬件名称": "Hardware Name",
  "硬件架构版本号": "Hardware Architecture Version Number",
  "硬件类型": "Hardware Type",
  "硬件编号": "Hardware Number",
  "硬件详情": "Hardware Details",
  "确定": "Ok",
  "确定启用该角色吗？": "Are You Sure To Enable This Role?",
  "确定导入": "Confirm Import",
  "确定执行此操作吗？": "Are you sure to do this?",
  "确定禁用该角色吗？": "Are You Sure To Disable This Role?",
  "确认": "Confirm",
  "确认修改以下": "Confirm To Modify The Following",
  "确认密码": "Confirm Password",
  "确认提交后，部分数据存在更新延迟，请在一分钟后前往设备操作日志查看": "After Confirming The Submission, Some Data Is Delayed. Check The Device Operation Log One Minute Later",
  "确认版本号": "Confirm Version Number",
  "确认要删除这条菜单吗": "Are You Sure You Want To Delete This Menu",
  "确认要远程重启": "Confirm That You Want To Remotely Restart",
  "确认设备": "Confirmation Equipment",
  "禁用": "Disabled",
  "禁用后，用户无法登录系统，您确定要禁用吗": "After Disabling The Function, Users Cannot Log In To The System. Are You Sure You Want To Disable The Function",
  "禁用后企业下所有账号将无法使用，是否禁用?": "After The Enterprise Account Is Disabled, All Accounts In The Enterprise Cannot Be Used. Do You Want To Disable It?",
  "禁用或启用固件版本提示": "Whether Or Not{status}this Firmware Version",
  "离线": "Offline",
  "离线启动": "Offline Boot",
  "私桩": "Private Charger",
  "私桩场站": "Private Charger Station",
  "移除": "Remove",
  "税号": "Duty Number",
  "税号类别": "Tax Number Category",
  "空闲": "Free",
  "立即执行": "Immediate Execution",
  "端口": "Port",
  "签收信息总长度不能超过128": "The Total Length Of The Sign-off Message Cannot Exceed 128",
  "签署日期不能为空": "The Signing Date Cannot Be Empty",
  "类型": "Type",
  "系统": "System",
  "组织机构代码": "Organization Code",
  "绑定成功": "Binding Successful",
  "结束日期": "End Date",
  "续保开始时间": "Renewal Start Time",
  "续保时间": "Renewal Time",
  "续保结束时间": "Renewal End Time",
  "维护中": "Maintenance In Progress",
  "编辑": "Edit",
  "编辑固件": "Edit Firmware",
  "编辑物料编码": "Edit Material Code",
  "编辑用户": "Edit User",
  "编辑角色": "Editor Role",
  "美洲": "America",
  "联营": "Joint Operation",
  "能源控制器": "Energy Controller",
  "能源设备信息": "Energy Equipment Information",
  "自定义升级": "Custom Upgrade",
  "若迁移成功，由于数据存在更新延迟，请一分钟后在列表刷新查看": "Note If The Migration Is Successful, Refresh The List One Minute Later Due To Data Update Delay",
  "英文按钮名称": "English Button Name",
  "英文菜单名称": "English Menu Name",
  "获取最新配置": "Get The Latest Configuration",
  "获取设备当前版本": "Obtain The Current Version Of The Device",
  "获取配置文件": "Get Configuration File",
  "菜单": "Menu",
  "菜单权限": "Menu Permissions",
  "菜单状态": "Menu Status",
  "菜单类型": "Menu Type",
  "蓝牙模块": "Bluetooth Module",
  "角色名称": "Role name",
  "角色绑定": "Role Binding",
  "设备SN码": "Device Sn Code",
  "设备SN码重复": "The Sn Code Of The Device Is Repeated",
  "设备SN码长度不能大于20": "The Length Of The Device Sn Cannot Exceed 20",
  "设备上下线时间不能为空": "The Time For Getting The Device Online And Off Cannot Be Empty",
  "设备不在线": "Device Offline",
  "设备不存在": "Device Does Not Exist",
  "设备不支持当前选择的模板": "The Device Does Not Support The Selected Template",
  "设备二维码格式必须是8位数字": "The Device Qr Code Format Must Be 8 Digits",
  "设备制造商": "Equipment Manufacturer",
  "设备名称": "Device Name",
  "设备型号": "Equipment Type",
  "设备型号不能为空": "The Device Model Cannot Be Empty",
  "设备型号长度不能大于50": "The Length Of The Device Model Cannot Exceed 50",
  "设备对象": "Device Object",
  "设备所有者不能为空": "The Device Owner Cannot Be Empty",
  "设备所有者应输入9位数字或大小写字母": "The Device Owner Should Enter 9 Digits Or Upper And Lower Case Letters",
  "设备状态": "Device Status",
  "设备端配置": "Device-side Configuration",
  "设备类型": "Device Type",
  "设备类型不能为空或者数据错误": "The Device Type Cannot Be Null Or The Data Is Incorrect",
  "设备编号": "Equipment Number",
  "设备编号不能为空": "The Device Number Cannot Be Empty",
  "设备编号重复": "Duplicate Device Number",
  "设备编码": "Device Coding",
  "设备运维方": "Equipment Operation And Maintenance Party",
  "设备运维方不能为空或者数据错误": "The O&m Side Of The Device Cannot Be Empty Or Have Incorrect Data",
  "设备运营方不能为空": "The Equipment Operator Cannot Be Empty",
  "设备运营方应输入9位数字或大小写字母": "The Equipment Operator Should Enter 9 Digits Or Upper And Lower Case Letters",
  "设备额定功率不能为空": "The Rated Power Of The Device Cannot Be Empty",
  "设备额定功率大小范围为0~9998": "The Rated Power Ranges From 0 To 9998",
  "设置屏保": "Set Screensaver",
  "该用户没有菜单权限": "This User Does Not Have Menu Permissions",
  "该账户在用户中心已存在": "The Account Already Exists In The User Center",
  "详情": "Detail",
  "详细地址": "Detailed Address",
  "详细地址长度不能超过200": "The Length Of The Detailed Address Cannot Exceed 200",
  "说明": "Instructions",
  "请上传文件": "Please Upload File",
  "请上传模板": "Please upload template",
  "请上传添加Excel表格": "Please Upload And Add Excel Spreadsheet",
  "请上传符合标准的文件": "Please Upload Files That Meet The Standards",
  "请导入设备": "Please Import Device",
  "请求上传失败": "Request Upload Failed",
  "请求地址": "Request Address",
  "请添加产品序列": "Please Add Product Sequence",
  "请添加数量小于100的Excel表格": "Add The Number Of Excel Tables Less Than 100",
  "请添加数量小于200的Excel表格": "Add The Number Of Excel Tables Less Than 200",
  "请输入": "Please enter",
  "请输入，限100字": "Please Enter, Limited To 100 Words",
  "请输入100字符以内": "Please Enter 100 Characters Or Less",
  "请输入20字以内的用户名称": "Please Enter A User Name In 20 Characters Or Less",
  "请输入20字以内的账户名称": "Please Enter Your Account Name In 20 Words Or Less",
  "请输入300字以内": "Please Enter 300 Words Or Less",
  "请输入6-18位密码！": "Please Enter A 6-18 Digit Password!",
  "请输入7-18位手机号": "Please Enter 7-18 Digits Mobile Phone Number",
  "请输入9位数字或大小写字母的组织机构代码": "Please Enter The Organization Code With 9 Digits Or Upper And Lower Case Letters",
  "请输入中文按钮名称": "Please Enter A Chinese Button Name",
  "请输入中文菜单名称": "Please Enter A Chinese Menu Name",
  "请输入任务名称": "Please Enter A Task Name",
  "请输入企业名称": "Please Enter The Business Name",
  "请输入企业状态": "Please Enter The Enterprise Status",
  "请输入固件号": "Please Enter The Firmware Number",
  "请输入备注内容": "Please Enter Remarks",
  "请输入字母/数字两种类型的组合！": "Please Enter A Combination Of Letters/numbers!",
  "请输入权限标识": "Please Enter A Permission Identifier",
  "请输入组织机构代码": "Please Enter The Organization Code",
  "请输入英文按钮名称": "Please Enter The English Button Name",
  "请输入英文菜单名称": "Please Enter The English Menu Name",
  "请输入角色名称": "Please Enter A Role Name",
  "请输入详细地址": "Please Enter The Full Address",
  "请输入负责人姓名": "Please Enter The Name Of The Person Responsible",
  "请输入负责人电话": "Please Enter The Phone Number Of The Person In Charge",
  "请输入负责人身份证号": "Please Enter The Responsible Person Id Number",
  "请输入账户名称": "Please Enter Your Account Name",
  "请输入路由地址": "Please Enter A Routing Address",
  "请选择": "Please select",
  "请选择任务类型": "Please Select A Task Type",
  "请选择企业": "Please Select A Business",
  "请选择企业类型": "Please Select A Business Type",
  "请选择升级方式": "Select An Upgrade Mode",
  "请选择发送方式": "Please select Sending Method",
  "请选择员工": "Please Select An Employee",
  "请选择固件号": "Please Select Firmware Number",
  "请选择固件号及固件版本": "Please Select The Firmware Number And Firmware Version",
  "请选择固件版本": "Please Select A Firmware Version",
  "请选择国家!": "Please Select A Country!",
  "请选择国家代码": "Please Select A Country Code",
  "请选择地区": "Please Select A Region",
  "请选择地区!": "Please Select A Region!",
  "请选择执行的任务类型": "Select A Task Type To Execute",
  "请选择是否弹窗": "Please select Whether Popup",
  "请选择目标平台": "Please select Target Platform",
  "请选择硬件类型": "Please Select A Hardware Type",
  "请选择菜单类型": "Please Select A Menu Type",
  "请选择设备": "Please Select Device",
  "请选择设备以及配置": "Please select device and configuration",
  "请选择设备修改后的状态": "Select The Modified Device Status",
  "请选择设备对象": "Please Select A Device Object",
  "请选择设备类型": "Please Select The Device Type",
  "请选择通知对象": "Please select Notification Object",
  "请选择需升级的固件号": "Select The Firmware Number You Want To Upgrade",
  "请选择需升级的固件版本": "Select The Firmware Version You Want To Upgrade",
  "调试信息总长度不能超过128": "The Total Length Of Debugging Information Cannot Exceed 128",
  "负责人姓名": "Name Of Person In Charge",
  "负责人电话": "Person In Charge Telephone",
  "负责人身份证号": "Responsible Person Id Number",
  "负载电表": "Load Meter",
  "账户名称": "Account Name",
  "质保信息": "Warranty Information",
  "质保到期": "Warranty Expires",
  "质保开始不能大于结束时间": "The Warranty Start Time Cannot Be Longer Than The End Time",
  "质保开始时间": "Warranty Start Time",
  "质保开始结束时间不能为空": "The Warranty Start And End Time Cannot Be Empty",
  "质保开始结束时间格式错误": "The Warranty Start And End Time Format Is Incorrect",
  "质保时间": "Warranty Time",
  "质保结束时间": "Warranty End Time",
  "资源链接": "Resource Link",
  "路由地址": "Routing Address",
  "身份证号不正确": "The Id Number Is Incorrect",
  "车位占用": "Parking Space Occupancy",
  "软件平台版本号": "Software Platform Version Number",
  "软件文件命名规则下载": "Software File Naming Rules Download",
  "软件逻辑版本号": "Software Logic Version Number",
  "辅助电压不能为空": "The Auxiliary Voltage Cannot Be Empty",
  "辅助电压大小范围为0~9999": "The Auxiliary Voltage Ranges From 0 To 9999",
  "输入输出接口板卡": "I/o Interface Board",
  "迁移": "Transfer",
  "运维": "Operation And Maintenance",
  "运维-私桩": "Operation And Maintenance - Private Charger",
  "运维-非私桩": "Operation And Maintenance - Non-private Charger",
  "运维等级": "Operation And Maintenance Level",
  "运营": "Operate",
  "运营-人人场站": "Operation - Renren Station",
  "运营-他营": "Operation - He Camp",
  "运营-加盟直营": "Operation - Joint Direct Operation",
  "运营-星充直营": "Operation - StarCharge Direct Operation",
  "运营-联营": "Operation - Joint Venture",
  "运营归属": "Operating Ownership",
  "运营类型": "Type Of Operation",
  "运行版本信息": "Running Version Information",
  "返回上一步会清空当前页面数据， 是否确定返回上一步?": "Returning To The Previous Step Will Clear The Current Page Data. Are You Sure To Return To The Previous Step?",
  "远程重启": "Remote Restart",
  "逆变器": "Inverter",
  "选择": "Select",
  "选择产品序列": "Select Product Sequence",
  "选择人员": "Select Personnel",
  "选择场站": "Selective Terminal",
  "选择客户": "Select Customer",
  "选择文件": "Select File",
  "选择设备": "Select Device",
  "选择通知对象": "Select Notification Object",
  "通信拓扑": "Communication Topology",
  "通知内容": "Notification Content",
  "通知对象": "Notification Object",
  "通知标题": "Notification Title",
  "通讯地址": "Mailing Address",
  "通讯棒": "Communication Stick",
  "邮箱": "Mailbox",
  "邮箱格式不正确": "The Mailbox Format Is Incorrect",
  "部分校验成功，是否继续": "If The Verification Is Partially Successful, Determine Whether To Continue",
  "配置下载": "Configuration Download",
  "配置信息": "Configuration",
  "配置修改": "Configuration Modification",
  "配置内容": "Configuration Content",
  "配置内容不能为空！": "The Configuration Content Cannot Be Empty!",
  "配置最新上报时间": "The Latest Report Time Was Set",
  "配置最新下发修改时间": "The Latest Delivery Change Time Was Set",
  "配置最新变更时间": "The Latest Change Time Was Set",
  "配置刷新": "Configuration Refresh",
  "配置名称": "Configuration Name",
  "配置字段": "Configuration Field",
  "配置导出": "Configuration Export",
  "配置文件版本号": "Configuration File Version Number",
  "配置文件设备数量不大于200个，超过时建议减少桩数量，分批修改": "The Number Of Devices In The Configuration File Cannot Exceed 200. If The Number Exceeds 200, Reduce The Number Of Piles And Change Them In Batches",
  "配置选择": "Configuration Selection",
  "重新上传": "Re-upload",
  "重置": "Reset",
  "重置后，密码将恢复默认，您确定要重置吗？": "After Reset, The Password Will Revert To Default. Are You Sure You Want To Reset It?",
  "重置密码": "Reset Password",
  "链接": "Link",
  "销售合同总长度不能超过128": "The Total Length Of The Sales Contract Shall Not Exceed 128",
  "销售渠道不能为空或者数据错误": "The Sales Channel Must Not Be Empty Or Have Incorrect Data",
  "锁定状态不允许充电": "The Locked State Does Not Allow Charging",
  "错误信息": "Error Message",
  "阅读情况": "Reading Status",
  "隐藏": "Hidden",
  "零件信息": "Part Information",
  "非私桩": "Non-private Charger",
  "项参数吗？": "Item Parameter?",
  "项目编号不能为空": "The Item Number Cannot Be Empty",
  "项目编号长度不能超过32": "The Length Of The Item Number Cannot Exceed 32",
  "预约等待充电中": "Make An Appointment To Wait For Charging",
  "预览": "Preview",
  "高压": "High Tension",
  "默认为ftp升级打开后为流式升级(此按钮不打开不支持TCP升级)": "By default, it is ftp upgrade. Once enabled, it is a streaming upgrade. (If this button is not enabled, TCP upgrade is not supported.)",
  "充电桩编号": "Charger Id",
  "系统将自动录入信息，处理结果将以飞书方式发送给您！": "The system will automatically input the information, and the processing result will be sent to you via Feishu!",
};
